import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoWhite from "../assets/img/logo-white.png";


const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isPageOpen, setIsPageOpen] = useState(false);
    const [isHostingOpen, setIsHostingOpen] = useState(false);
    const [isDomainOpen, setIsDomainOpen] = useState(false);
    const [isAffOpen, setIsAffOpen] = useState(false);
    const [isComOpen, setIsComOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    return (
        <header id="header" className="header-main">
            <div id="logoAndNav" className={`main-header-menu-wrap bg-transparent fixed-top ${scrolled ? 'affix' : ''}`}>
                <div className="container">
                    <nav className="js-mega-menu navbar navbar-expand-md header-nav">
                        <a className="navbar-brand pt-0" href="index.html">
                            <img src={logoWhite} alt="logo"/>
                        </a>
                        <button type="button" className="navbar-toggler btn" data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasLeft">
                            <span id="hamburgerTrigger">
                <span className="fas fa-bars"></span>
                            </span>
                        </button>
                        <div id="navBar" className="collapse navbar-collapse">
                            <ul className="navbar-nav ms-auto main-navbar-nav">
                                <li className={`nav-item hs-has-mega-menu custom-nav-item ${ isOpen ? `hs-mega-menu-opened`:``}` }
                                    data-position="center"
                                    onMouseEnter={() => setIsOpen(true)}
                                    onMouseLeave={() => setIsOpen(false)}
                                >
                                    <a id="homeMegaMenu" className="nav-link custom-nav-link main-link-toggle"
                                       href="#" aria-haspopup="true"
                                       aria-expanded={isOpen}
                                       aria-expanded="false" onClick={(e) => e.preventDefault()}>
                                        Home
                                    </a>

                                    {isOpen && (
                                        <div className={`hs-mega-menu main-sub-menu w-100 ${isOpen ? 'd-block' : 'd-none'}`}>
                                            <div className="row g-0">
                                                <div className="col-lg-5 col-sm-6 col-12 gray-light-bg custom-radius-left">
                                                    <div className="menu-item-wrap p-4">
                                                        <h6>#1 Web Hosting Company</h6>
                                                        <p>
                                                            Get your website, web store or application online using
                                                            our reliable and fast hosting.
                                                        </p>
                                                        <ul className="list-unstyled content-feature-list mb-2">
                                                            <li>
                                                                <i className="fas fa-check-circle text-success pe-2"></i>
                                                                Managed cloud
                                                            </li>
                                                            <li>
                                                                <i className="fas fa-check-circle text-success pe-2"></i>
                                                                Business continuity
                                                            </li>
                                                            <li>
                                                                <i className="fas fa-check-circle text-success pe-2"></i>
                                                                IT/Cloud consultancy
                                                            </li>
                                                            <li>
                                                                <i className="fas fa-check-circle text-success pe-2"></i>
                                                                Load and stress testing
                                                            </li>
                                                            <li>
                                                                <i className="fas fa-check-circle text-success pe-2"></i>
                                                                Managed Kubernetes
                                                            </li>
                                                            <li>
                                                                <i className="fas fa-check-circle text-success pe-2"></i>
                                                                Managed Multi-datacenter
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-lg-7 col-sm-6 col-12 custom-radius-right">
                                                    <div className="row no-gutters p-4">
                                                        <div className="col-sm-12">
                                                            <span className="sub-menu-title">Home different style</span>
                                                            <ul className="home-demo-list">
                                                                <li>
                                                                    <a href="index.html">
                                                                        <i className="far fa-hard-drive me-2"></i>
                                                                        Home Default
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-image.html">
                                                                        <i className="far fa-file-image me-2"></i>
                                                                        Home Image
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-slider.html">
                                                                        <i className="far fa-clone me-2"></i>
                                                                        Home Content Slider
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-gaming.html">
                                                                        <i className="far fa-gem me-2"></i>
                                                                        Home Gaming Hosting
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-video.html">
                                                                        <i className="far fa-file-video me-2"></i>
                                                                        Home Background Video
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-black-friday.html">
                                                                        <i className="far fa-lightbulb me-2"></i>
                                                                        Home Black Friday Sale
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-black-friday-coming.html">
                                                                        <i className="far fa-circle-dot me-2"></i>
                                                                        Home Black Friday Coming
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="index-top-navbar.html">
                                                                        <i className="far fa-hard-drive me-2"></i>
                                                                        Home Top Navbar
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="u-header__product-banner">
                                                        <div
                                                            className="u-header__product-banner-content text-center text-white">
                                                            <div className="mb-4">
                                                                <h5 className="text-white">Get 25% Discount Start Now</h5>
                                                                <ul className="list-unstyled list-inline menu-countdown my-4">
                                                                    <li className="list-inline-item mb-0">
                                                                    <span
                                                                        className="counter-days border border-light fs-sm text-light p-2 rounded fw-medium"
                                                                    ></span>
                                                                    </li>
                                                                    <li className="list-inline-item mb-0">
                                                                    <span
                                                                        className="counter-hours border border-light fs-sm text-light p-2 rounded fw-medium"
                                                                    ></span>
                                                                    </li>
                                                                    <li className="list-inline-item mb-0">
                                                                    <span
                                                                        className="counter-minutes border border-light fs-sm text-light p-2 rounded fw-medium"
                                                                    ></span>
                                                                    </li>
                                                                    <li className="list-inline-item mb-0">
                                                                    <span
                                                                        className="counter-seconds border border-light fs-sm text-light p-2 rounded fw-medium"
                                                                    ></span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <a className="btn btn-tertiary mt-2" href="#">
                                                                Get start now
                                                                <span className="fas fa-arrow-right ps-2"></span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </li>
                                <li className={`nav-item hs-has-mega-menu custom-nav-item ${ isPageOpen ? `hs-mega-menu-opened`:``}` }
                                    onMouseEnter={() => setIsPageOpen(true)}
                                    onMouseLeave={() => setIsPageOpen(false)}
                                >
                                    <a id="pagesMegaMenu" className="nav-link custom-nav-link main-link-toggle"
                                       href="#" aria-haspopup="true"
                                       aria-expanded={isPageOpen}
                                       aria-labelledby="pagesSubMenu">
                                        Pages
                                    </a>
                                    {isPageOpen &&
                                        <ul id="pagesSubMenu"  className={`hs-mega-menu main-sub-menu w-100 ${isPageOpen ? 'd-block' : 'd-none'}`}
                                            aria-labelledby="pagesMegaMenu" style={{ minWidth: "230px"}}>
                                            <li className="nav-item submenu-item">
                                                <a className="nav-link sub-menu-nav-link" href="about-us.html">
                                                    About Us
                                                </a>
                                            </li>
                                            <li className="nav-item submenu-item">
                                                <a className="nav-link sub-menu-nav-link" href="offer-single-page.html">
                                                    Black Friday Single
                                                </a>
                                            </li>
                                            <li className="nav-item submenu-item">
                                                <a className="nav-link sub-menu-nav-link" href="terms-condition.html">
                                                    Terms & Condition
                                                </a>
                                            </li>
                                            <li className="nav-item submenu-item">
                                                <a className="nav-link sub-menu-nav-link" href="privacy-policy.html">
                                                    Privacy Policy
                                                </a>
                                            </li>
                                            <li className="hs-has-sub-menu">
                                                <a id="navLinkPagesPricing"
                                                   className="nav-link sub-menu-nav-link sub-link-toggle"
                                                   href="javascript:void(0);" aria-haspopup="true" aria-expanded="false"
                                                   aria-controls="navSubmenuPagesPricing">
                                                    Pricing
                                                </a>
                                                <ul id="navSubmenuPagesPricing" className="hs-sub-menu main-sub-menu"
                                                    aria-labelledby="navLinkPagesPricing" style={{minwidth: "230px"}}>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="pricing-default.html">
                                                            Pricing Default
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="pricing-package.html">
                                                            Pricing Packages
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="pricing-web-hosting.html">
                                                            Web Hosting Packages
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="pricing-windows-hosting.html">
                                                            Windows Hosting
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="pricing-comparision.html">
                                                            Pricing Comparison
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="pricing-specifications.html">
                                                            Pricing Specifications
                                                            <span className="badge bg-danger ms-auto">New</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="vps-pricing.html">
                                                            VPS Pricing
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="hs-has-sub-menu">
                                                <a id="navLinkPagesBlog"
                                                   className="nav-link sub-menu-nav-link sub-link-toggle"
                                                   href="javascript:void(0);" aria-haspopup="true" aria-expanded="false"
                                                   aria-controls="navSubmenuPagesBlog">
                                                    Blog
                                                </a>
                                                <ul id="navSubmenuPagesBlog" className="hs-sub-menu main-sub-menu"
                                                    aria-labelledby="navLinkPagesBlog" style={{minWidth: "230px"}}>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="blog-grid.html">
                                                            Blog Grid
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="blog-details.html">
                                                            Blog Details
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="hs-has-sub-menu">
                                                <a id="navLinkPagesSpecialty"
                                                   className="nav-link sub-menu-nav-link sub-link-toggle"
                                                   href="javascript:void(0);" aria-haspopup="true" aria-expanded="false"
                                                   aria-controls="navSubmenuPagesSpecialty">
                                                    Specialty
                                                </a>
                                                <ul id="navSubmenuPagesSpecialty" className="hs-sub-menu main-sub-menu"
                                                    aria-labelledby="navLinkPagesSpecialty" style={{minWidth: "230px"}}>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="domain-search-result.html">
                                                            Search Result
                                                            <span className="badge bg-success ms-2">New</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="cover-page.html">
                                                            Cover Page
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="coming-soon.html">
                                                            Coming Soon
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="thank-you.html">
                                                            Thank You
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="404.html">
                                                            Error 404
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="hs-has-sub-menu">
                                                <a id="navLinkPagesLogin"
                                                   className="nav-link sub-menu-nav-link sub-link-toggle"
                                                   href="javascript:void(0);" aria-haspopup="true" aria-expanded="false"
                                                   aria-controls="navSubmenuPagesLogin">
                                                    Login &amp; Signup
                                                </a>
                                                <ul id="navSubmenuPagesLogin" className="hs-sub-menu main-sub-menu"
                                                    aria-labelledby="navLinkPagesLogin" style={{minWidth: "230px"}}>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="login.html">
                                                            Login
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link" href="sign-up.html">
                                                            Signup
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="nav-link sub-menu-nav-link"
                                                           href="password-reset.html">
                                                            Recover Account
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    }
                                </li>
                                <li className="nav-item hs-has-mega-menu custom-nav-item position-relative"
                                    data-position="center">
                                    <a id="hostingMegaMenu" className="nav-link custom-nav-link main-link-toggle"
                                       href="JavaScript:Void(0);" aria-haspopup="true" aria-expanded="false">
                                        Hosting
                                    </a>
                                    <div className="hs-mega-menu main-sub-menu" style={{width: "715px"}}
                                         aria-labelledby="hostingMegaMenu">
                                        <div className="row g-0">
                                            <div className="col-md-6">
                                                <div className="menu-item-wrap py-0 p-md-3 p-lg-3">
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link" href="shared-hosting.html">
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-item-icon pe-3">
                                                                    <i
                                                                        className="fas fa-server rounded-circle primary-bg"
                                                                    ></i>
                                                                </div>
                                                                <div className="media-body">
                                                                    <span className="u-header__promo-title">
                                    Shared Web Hosting
                                  </span>
                                                                    <small className="u-header__promo-text">
                                                                        Reliable quality Starting at
                                                                        <strong>$2.99</strong>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link" href="vps-hosting.html">
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-item-icon pe-3">
                                                                    <i
                                                                        className="fas fa-box rounded-circle accent-bg"
                                                                    ></i>
                                                                </div>
                                                                <div className="media-body">
                                                                    <span className="u-header__promo-title">
                                    VPS Hosting
                                  </span>
                                                                    <small className="u-header__promo-text">
                                                                        Maintain Starting at
                                                                        <strong>$11.99</strong>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link" href="cloud-hosting.html">
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-item-icon pe-3">
                                                                    <i
                                                                        className="fas fa-cloud rounded-circle secondary-bg"
                                                                    ></i>
                                                                </div>
                                                                <div className="media-body">
                                                                    <span className="u-header__promo-title">
                                    Cloud Hosting
                                  </span>
                                                                    <small className="u-header__promo-text">
                                                                        Cloud Starting at
                                                                        <strong>$5.99/mo</strong>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="menu-item-wrap py-0 p-md-3 p-lg-3">
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link" href="email-hosting.html">
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-item-icon pe-3">
                                                                    <i
                                                                        className="fas fa-envelope rounded-circle twitter-bg"
                                                                    ></i>
                                                                </div>
                                                                <div className="media-body">
                                                                    <span className="u-header__promo-title">
                                    Email Hosting
                                  </span>
                                                                    <small className="u-header__promo-text">
                                                                        First Starting at
                                                                        <strong>$0.99/mo</strong>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link"
                                                           href="windows-vps-hosting.html">
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-item-icon pe-3">
                                                                    <i
                                                                        className="fab fa-windows rounded-circle bg-success"
                                                                    ></i>
                                                                </div>
                                                                <div className="media-body">
                                                                    <span className="u-header__promo-title">
                                    Windows VPS Hosting
                                  </span>
                                                                    <small className="u-header__promo-text">
                                                                        Globally Starting at
                                                                        <strong>$9.99/mo</strong>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link"
                                                           href="dedicated-server-hosting.html">
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-item-icon pe-3">
                                                                    <i
                                                                        className="fas fa-database rounded-circle dribbble-bg"
                                                                    ></i>
                                                                </div>
                                                                <div className="media-body">
                                                                    <span className="u-header__promo-title">
                                    Dedicated Server Hosting
                                  </span>
                                                                    <small className="u-header__promo-text">
                                                                        Conveniently Starting at
                                                                        <strong>$9.99/mo</strong>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="application-hosting text-white">
                                            <span
                                                className="sub-menu-title text-lg-center text-md-center text-white mb-3"
                                            >
                        Application For Hosting
                      </span>
                                            <ul className="application-hosting-list">
                                                <li>
                                                    <a href="wp-hosting.html">
                                                        <img src={logoWhite}  alt="icon"/>
                                                        WordPress Hosting
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="joomla-hosting.html">
                                                        <img src="assets/img/icons/joomla-icon-color.svg" alt="icon"/>
                                                        Joomla Hosting
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="magento-hosting.html">
                                                        <img src="assets/img/icons/magento-icon-color.svg" alt="icon"/>
                                                        Magento Hosting
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="opencart-hosting.html">
                                                        <img src="assets/img/icons/opencart-icon-color.svg" alt="icon"/>
                                                        Opencart Hosting
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="prestashop-hosting.html">
                                                        <img src="assets/img/icons/prestashop-icon-color.svg"
                                                             alt="icon"/>
                                                        Prestashop Hosting
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="drupal-hosting.html">
                                                        <img src="assets/img/icons/drupal-icon-color.svg" alt="icon"/>
                                                        Drupal Hosting
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item hs-has-mega-menu custom-nav-item position-relative"
                                    data-position="center">
                                    <a id="domainMegaMenu" className="nav-link custom-nav-link main-link-toggle"
                                       href="JavaScript:Void(0);" aria-haspopup="true" aria-expanded="false">
                                        Domain
                                    </a>
                                    <div className="hs-mega-menu main-sub-menu" style={{width: "660px"}}
                                         aria-labelledby="domainMegaMenu">
                                        <div className="row g-0">
                                            <div className="col-md-6 col-sm-6">
                                                <div className="menu-item-wrap p-3">
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link" href="domain-checker.html">
                                                            <div className="d-flex align-items-center pb-1">
                                                                <i className="fas fa-globe me-2 color-primary"></i>
                                                                <span className="u-header__promo-title">
                                  Domain Checker
                                </span>
                                                            </div>
                                                            <small className="u-header__promo-text">
                                                                Find the perfect domain for your business
                                                            </small>
                                                        </a>
                                                    </div>
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link" href="domain-transfer.html">
                                                            <div className="d-flex align-items-center pb-1">
                                                                <i
                                                                    className="fas fa-exchange-alt me-2 color-accent"
                                                                ></i>
                                                                <span className="u-header__promo-title">
                                  Domain Transfer
                                </span>
                                                            </div>
                                                            <small className="u-header__promo-text">
                                                                Transfer your domain easily
                                                            </small>
                                                        </a>
                                                    </div>
                                                    <div className="title-with-icon-item">
                                                        <a className="title-with-icon-link"
                                                           href="domain-registration.html">
                                                            <div className="d-flex align-items-center pb-1">
                                                                <i
                                                                    className="fas fa-copyright me-2 instagram-color"
                                                                ></i>
                                                                <span className="u-header__promo-title">
                                  Domain Registration
                                </span>
                                                            </div>
                                                            <small className="u-header__promo-text">
                                                                Register your domain name for lifetime
                                                            </small>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-6 gray-light-bg custom-radius-right">
                                                <div className="menu-item-wrap p-4">
                                                    <h6>#1 Web Hosting Company</h6>
                                                    <ul className="list-unstyled tech-feature-list">
                                                        <li className="py-1">
                                                            <small>
                                                                <span
                                                                    className="fas fa-check-circle text-success me-2"
                                                                ></span>
                                                                <strong>Flexible</strong>
                                                                Easy to Use Control Panel
                                                            </small>
                                                        </li>
                                                        <li className="py-1">
                                                            <small>
                                                                <span
                                                                    className="fas fa-check-circle text-success me-2"
                                                                ></span>
                                                                <strong>99%</strong>
                                                                Uptime Guarantee
                                                            </small>
                                                        </li>
                                                        <li className="py-1">
                                                            <small>
                                                                <span
                                                                    className="fas fa-check-circle text-success me-2"
                                                                ></span>
                                                                <strong>45-Day</strong>
                                                                Money-Back Guarantee
                                                            </small>
                                                        </li>
                                                        <li className="py-1">
                                                            <small>
                                                                <span
                                                                    className="fas fa-check-circle text-success me-2"
                                                                ></span>
                                                                <strong>Free SSL</strong>
                                                                Certificate Included
                                                            </small>
                                                        </li>
                                                    </ul>
                                                    <a className="btn btn-tertiary btn-block mt-3" href="#">
                                                        Learn More
                                                        <span className="fas fa-angle-right ms-2"></span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item custom-nav-item">
                                    <a className="nav-link custom-nav-link" href="affiliates.html">
                                        Affiliates
                                    </a>
                                </li>
                                <li className="nav-item hs-has-mega-menu custom-nav-item position-relative"
                                    data-position="center">
                                    <a id="aboutMegaMenu" className="nav-link custom-nav-link main-link-toggle"
                                       href="JavaScript:Void(0);" aria-haspopup="true" aria-expanded="false">
                                        Company
                                    </a>
                                    <div className="hs-mega-menu main-sub-menu" style={{width: "320px"}}
                                         aria-labelledby="aboutMegaMenu">
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="contact-us.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/chat-mobile.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Contact Us</span>
                                                        <small className="u-header__promo-text">
                                                            Face any problem contact with us
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="about-us.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/community.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">About Us</span>
                                                        <small className="u-header__promo-text">
                                                            We are leading hosting company
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="partners.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/partner.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Our Partner</span>
                                                        <small className="u-header__promo-text">
                                                            We have trusted partners globally
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="network.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/network.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Network</span>
                                                        <small className="u-header__promo-text">
                                                            Keep your data save and secure
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="blog-grid.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/blog.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Company Blog</span>
                                                        <small className="u-header__promo-text">
                                                            Industry latest technology news & tips
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item header-nav-last-item d-flex align-items-center">
                                    <a className="btn btn-tertiary animated-btn"
                                       href="https://whmcs.themetags.com/index.php?systpl=kohost&carttpl=themetags_cart"
                                       target="_blank">
                                        <span className="fa fa-user pe-2"></span>
                                        Client Area
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
            <div className="offcanvas offcanvas-start" id="offcanvasLeft" tabIndex="-1">
                <div className="offcanvas-header border-bottom">
                    <a className="navbar-brand" href="index.html">
                        <img src={logoWhite} alt="logo" className="img-fluid"/>
                    </a>
                    <button className="btn-close" type="button" data-bs-dismiss="offcanvas"></button>
                </div>
                <div className="offcanvas-body offcanvas-menu-wrap">
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                Home
                            </a>
                            <div className="dropdown-menu p-0">
                                <div className="row g-0">
                                    <div className="col-12 gray-light-bg">
                                        <div className="menu-item-wrap p-4">
                                            <h6>#1 Web Hosting Company</h6>
                                            <p>
                                                Get your website, web store or application online using our
                                                reliable and fast hosting.
                                            </p>
                                            <ul className="list-unstyled content-feature-list mb-2">
                                                <li>
                                                    <i className="fas fa-check-circle text-success pe-2"></i>
                                                    Managed cloud
                                                </li>
                                                <li>
                                                    <i className="fas fa-check-circle text-success pe-2"></i>
                                                    Business continuity
                                                </li>
                                                <li>
                                                    <i className="fas fa-check-circle text-success pe-2"></i>
                                                    IT/Cloud consultancy
                                                </li>
                                                <li>
                                                    <i className="fas fa-check-circle text-success pe-2"></i>
                                                    Load and stress testing
                                                </li>
                                                <li>
                                                    <i className="fas fa-check-circle text-success pe-2"></i>
                                                    Managed Kubernetes
                                                </li>
                                                <li>
                                                    <i className="fas fa-check-circle text-success pe-2"></i>
                                                    Managed Multi-datacenter
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row no-gutters p-4">
                                            <div className="col-sm-12">
                                                <span className="sub-menu-title">Home different style</span>
                                                <ul className="home-demo-list">
                                                    <li>
                                                        <a href="index.html">
                                                            <i className="far fa-hard-drive me-2"></i>
                                                            Home Default
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-image.html">
                                                            <i className="far fa-file-image me-2"></i>
                                                            Home Image
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-slider.html">
                                                            <i className="far fa-clone me-2"></i>
                                                            Home Content Slider
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-gaming.html">
                                                            <i className="far fa-gem me-2"></i>
                                                            Home Gaming Hosting
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-video.html">
                                                            <i className="far fa-file-video me-2"></i>
                                                            Home Background Video
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-black-friday.html">
                                                            <i className="far fa-lightbulb me-2"></i>
                                                            Home Black Friday Sale
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-black-friday-coming.html">
                                                            <i className="far fa-circle-dot me-2"></i>
                                                            Home Black Friday Coming
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="index-top-navbar.html">
                                                            <i className="far fa-hard-drive me-2"></i>
                                                            Home Top Navbar
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="u-header__product-banner">
                                            <div className="u-header__product-banner-content text-center text-white">
                                                <div className="mb-4">
                                                    <h5 className="text-white">Get 25% Discount Start Now</h5>
                                                    <ul className="list-unstyled list-inline menu-countdown my-4">
                                                        <li className="list-inline-item mb-0">
                                                            <span
                                                                className="counter-days border border-light fs-sm text-light p-2 rounded fw-medium"
                                                            ></span>
                                                        </li>
                                                        <li className="list-inline-item mb-0">
                                                            <span
                                                                className="counter-hours border border-light fs-sm text-light p-2 rounded fw-medium"
                                                            ></span>
                                                        </li>
                                                        <li className="list-inline-item mb-0">
                                                            <span
                                                                className="counter-minutes border border-light fs-sm text-light p-2 rounded fw-medium"
                                                            ></span>
                                                        </li>
                                                        <li className="list-inline-item mb-0">
                                                            <span
                                                                className="counter-seconds border border-light fs-sm text-light p-2 rounded fw-medium"
                                                            ></span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <a className="btn btn-tertiary mt-2" href="#">
                                                    Get start now
                                                    <span className="fas fa-arrow-right ps-2"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown"
                               data-bs-auto-close="outside">
                                Pages
                            </a>
                            <ul className="dropdown-menu">
                                <li>
                                    <a className="dropdown-item" href="about-us.html">About Us</a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="offer-single-page.html">
                                        Black Friday Single
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="terms-condition.html">
                                        Terms & Condition
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="privacy-policy.html">
                                        Privacy Policy
                                    </a>
                                </li>
                                <li className="dropdown">
                                    <a className="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                        Pricing
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <a className="dropdown-item" href="pricing-default.html">
                                                Pricing Default
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="pricing-package.html">
                                                Pricing Packages
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="pricing-web-hosting.html">
                                                Web Hosting Packages
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="pricing-windows-hosting.html">
                                                Windows Hosting
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="pricing-comparision.html">
                                                Pricing Comparison
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="pricing-specifications.html">
                                                Pricing Specifications
                                                <span className="badge bg-danger ms-auto">New</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="vps-pricing.html">
                                                VPS Pricing
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="dropdown">
                                    <a className="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                        Blog
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <a className="dropdown-item" href="blog-grid.html">Blog Grid</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="blog-details.html">
                                                Blog Details
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="dropdown">
                                    <a className="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                        Specialty
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <a className="dropdown-item" href="domain-search-result.html">
                                                Search Result
                                                <span className="badge bg-success ms-2">New</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="cover-page.html">Cover Page</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="coming-soon.html">
                                                Coming Soon
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="thank-you.html">Thank You</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="404.html">Error 404</a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="dropdown">
                                    <a className="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                        Login and Signup
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <a className="dropdown-item" href="login.html">Login</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="sign-up.html">Signup</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="password-reset.html">
                                                Recover Account
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                Hosting
                            </a>
                            <div className="dropdown-menu p-0">
                                <div className="row g-0">
                                    <div className="col-12">
                                        <div className="menu-item-wrap py-0 p-md-3 p-lg-3">
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="shared-hosting.html">
                                                    <div className="d-flex align-items-center">
                                                        <div className="menu-item-icon pe-3">
                                                            <i
                                                                className="fas fa-server rounded-circle primary-bg"
                                                            ></i>
                                                        </div>
                                                        <div className="media-body">
                                                            <span className="u-header__promo-title">
                                Shared Web Hosting
                              </span>
                                                            <small className="u-header__promo-text">
                                                                Reliable quality Starting at
                                                                <strong>$2.99</strong>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="vps-hosting.html">
                                                    <div className="d-flex align-items-center">
                                                        <div className="menu-item-icon pe-3">
                                                            <i className="fas fa-box rounded-circle accent-bg"></i>
                                                        </div>
                                                        <div className="media-body">
                                                            <span className="u-header__promo-title">VPS Hosting</span>
                                                            <small className="u-header__promo-text">
                                                                Maintain Starting at
                                                                <strong>$11.99</strong>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="cloud-hosting.html">
                                                    <div className="d-flex align-items-center">
                                                        <div className="menu-item-icon pe-3">
                                                            <i
                                                                className="fas fa-cloud rounded-circle secondary-bg"
                                                            ></i>
                                                        </div>
                                                        <div className="media-body">
                                                            <span className="u-header__promo-title">
                                Cloud Hosting
                              </span>
                                                            <small className="u-header__promo-text">
                                                                Cloud Starting at
                                                                <strong>$5.99/mo</strong>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="menu-item-wrap py-0 p-md-3 p-lg-3">
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="email-hosting.html">
                                                    <div className="d-flex align-items-center">
                                                        <div className="menu-item-icon pe-3">
                                                            <i
                                                                className="fas fa-envelope rounded-circle twitter-bg"
                                                            ></i>
                                                        </div>
                                                        <div className="media-body">
                                                            <span className="u-header__promo-title">
                                Email Hosting
                              </span>
                                                            <small className="u-header__promo-text">
                                                                First Starting at
                                                                <strong>$0.99/mo</strong>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="windows-vps-hosting.html">
                                                    <div className="d-flex align-items-center">
                                                        <div className="menu-item-icon pe-3">
                                                            <i
                                                                className="fab fa-windows rounded-circle bg-success"
                                                            ></i>
                                                        </div>
                                                        <div className="media-body">
                                                            <span className="u-header__promo-title">
                                Windows VPS Hosting
                              </span>
                                                            <small className="u-header__promo-text">
                                                                Globally Starting at
                                                                <strong>$9.99/mo</strong>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link"
                                                   href="dedicated-server-hosting.html">
                                                    <div className="d-flex align-items-center">
                                                        <div className="menu-item-icon pe-3">
                                                            <i
                                                                className="fas fa-database rounded-circle dribbble-bg"
                                                            ></i>
                                                        </div>
                                                        <div className="media-body">
                                                            <span className="u-header__promo-title">
                                Dedicated Server Hosting
                              </span>
                                                            <small className="u-header__promo-text">
                                                                Conveniently Starting at
                                                                <strong>$9.99/mo</strong>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="application-hosting text-white">
                                    <span
                                        className="sub-menu-title text-lg-center text-md-center text-white mb-3"
                                    >
                    Application For Hosting
                  </span>
                                    <ul className="application-hosting-list">
                                        <li>
                                            <a href="wp-hosting.html">
                                                <img src="assets/img/icons/wordpress-icon-color.svg" alt="icon"/>
                                                WordPress Hosting
                                            </a>
                                        </li>
                                        <li>
                                            <a href="joomla-hosting.html">
                                                <img src="assets/img/icons/joomla-icon-color.svg" alt="icon"/>
                                                Joomla Hosting
                                            </a>
                                        </li>
                                        <li>
                                            <a href="magento-hosting.html">
                                                <img src="assets/img/icons/magento-icon-color.svg" alt="icon"/>
                                                Magento Hosting
                                            </a>
                                        </li>
                                        <li>
                                            <a href="opencart-hosting.html">
                                                <img src="assets/img/icons/opencart-icon-color.svg" alt="icon"/>
                                                Opencart Hosting
                                            </a>
                                        </li>
                                        <li>
                                            <a href="prestashop-hosting.html">
                                                <img src="assets/img/icons/prestashop-icon-color.svg" alt="icon"/>
                                                Prestashop Hosting
                                            </a>
                                        </li>
                                        <li>
                                            <a href="drupal-hosting.html">
                                                <img src="assets/img/icons/drupal-icon-color.svg" alt="icon"/>
                                                Drupal Hosting
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                Domain
                            </a>
                            <div className="dropdown-menu p-0">
                                <div className="row g-0">
                                    <div className="">
                                        <div className="menu-item-wrap p-3">
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="domain-checker.html">
                                                    <div className="d-flex align-items-center pb-1">
                                                        <i className="fas fa-globe me-2 color-primary"></i>
                                                        <span className="u-header__promo-title">
                              Domain Checker
                            </span>
                                                    </div>
                                                    <small className="u-header__promo-text">
                                                        Find the perfect domain for your business
                                                    </small>
                                                </a>
                                            </div>
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="domain-transfer.html">
                                                    <div className="d-flex align-items-center pb-1">
                                                        <i className="fas fa-exchange-alt me-2 color-accent"></i>
                                                        <span className="u-header__promo-title">
                              Domain Transfer
                            </span>
                                                    </div>
                                                    <small className="u-header__promo-text">
                                                        Transfer your domain easily
                                                    </small>
                                                </a>
                                            </div>
                                            <div className="title-with-icon-item">
                                                <a className="title-with-icon-link" href="domain-registration.html">
                                                    <div className="d-flex align-items-center pb-1">
                                                        <i className="fas fa-copyright me-2 instagram-color"></i>
                                                        <span className="u-header__promo-title">
                              Domain Registration
                            </span>
                                                    </div>
                                                    <small className="u-header__promo-text">
                                                        Register your domain name for lifetime
                                                    </small>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="gray-light-bg">
                                        <div className="menu-item-wrap p-4">
                                            <h6>#1 Web Hosting Company</h6>
                                            <ul className="list-unstyled tech-feature-list">
                                                <li className="py-1">
                                                    <small>
                                                        <span
                                                            className="fas fa-check-circle text-success me-2"
                                                        ></span>
                                                        <strong>Flexible</strong>
                                                        Easy to Use Control Panel
                                                    </small>
                                                </li>
                                                <li className="py-1">
                                                    <small>
                                                        <span
                                                            className="fas fa-check-circle text-success me-2"
                                                        ></span>
                                                        <strong>99%</strong>
                                                        Uptime Guarantee
                                                    </small>
                                                </li>
                                                <li className="py-1">
                                                    <small>
                                                        <span
                                                            className="fas fa-check-circle text-success me-2"
                                                        ></span>
                                                        <strong>45-Day</strong>
                                                        Money-Back Guarantee
                                                    </small>
                                                </li>
                                                <li className="py-1">
                                                    <small>
                                                        <span
                                                            className="fas fa-check-circle text-success me-2"
                                                        ></span>
                                                        <strong>Free SSL</strong>
                                                        Certificate Included
                                                    </small>
                                                </li>
                                            </ul>
                                            <a className="btn btn-tertiary btn-block mt-3" href="#">
                                                Learn More
                                                <span className="fas fa-angle-right ms-2"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="affiliates.html">Affiliates</a>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown"
                               data-bs-auto-close="outside">
                                Company
                            </a>
                            <div className="dropdown-menu">
                                <div className="row g-0">
                                    <div className="col-12">
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="contact-us.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/chat-mobile.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Contact Us</span>
                                                        <small className="u-header__promo-text">
                                                            Face any problem contact with us
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="about-us.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/community.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">About Us</span>
                                                        <small className="u-header__promo-text">
                                                            We are leading hosting company
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="partners.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/partner.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Our Partner</span>
                                                        <small className="u-header__promo-text">
                                                            We have trusted partners globally
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="network.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/network.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Network</span>
                                                        <small className="u-header__promo-text">
                                                            Keep your data save and secure
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="title-with-icon-item">
                                            <a className="title-with-icon-link" href="blog-grid.html">
                                                <div className="d-flex align-items-center">
                                                    <img className="menu-titile-icon" src="assets/img/blog.svg"
                                                         alt="SVG"/>
                                                    <div className="media-body">
                                                        <span className="u-header__promo-title">Company Blog</span>
                                                        <small className="u-header__promo-text">
                                                            Industry latest technology news & tips
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="nav-item header-nav-last-item d-flex align-items-center mt-3">
                            <a className="btn btn-tertiary animated-btn"
                               href="https://whmcs.themetags.com/index.php?systpl=kohost&carttpl=themetags_cart"
                               target="_blank">
                                <span className="fa fa-user pe-2"></span>
                                Client Area
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default Header;
